// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"EvLku","label":"_3vcIB","sortingItem":"_13549","icon":"_199kJ","clear":"_3XCjp","active":"_1noBW","rotate":"_3GcjG"};